import { AvailabilityCalendar } from '@data/models';
import { apiCall, IRequestOptions } from '../axios';

interface AvailabilityCalendarParams {
  property_id: number;
  start_date: string;
  end_date: string;
  lang?: string;
  promo_code?: string;
  allotment_block_code?: string;
  room_types?: number[];
}

export class AvailabilityCalendarService {
  static async search(
    params: AvailabilityCalendarParams,
    options: IRequestOptions = {}
  ) {
    const calendar = await apiCall(AvailabilityCalendar)(
      'post',
      '/availability_calendar',
      params,
      options
    );
    calendar.checkin = params.start_date;
    calendar.checkout = params.end_date;
    return calendar;
  }
}
